// extracted by mini-css-extract-plugin
export default {"block":"OneTimePaymentForm_block__hU7I6","container":"OneTimePaymentForm_container__lCJOL"};